<template>
  <div>
    <vxe-grid
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :cell-class-name="cellClassName"
      size="small"
      show-footer
      :seq-config="{
        startIndex: 0,
      }"
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:productName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SKU：{{ row.evgSkuNo }}</span>
      </template>
      <template v-slot:specName="{ row }">
        <span>{{ row.specName }}</span>
        <br />
        <span>{{ row.specNameEn }}</span>
        <br />
        <span>NO：{{ row.specNo }}</span>
      </template>
      <template v-slot:specInContainerQty="{ row }">
        {{ format(specInContainerQty(row)) }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { format, multiply, add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData
        .map((e) => {
          return e
        })
        .reduce((result, next) => {
          totalColumnFields.forEach((f) => {
            result[f] = add(result[f], next[f])
          })
          return result
        }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : val == 0 ? '0' : ''
        })
      result[2] = this.$l('INDEX.total') || '合计'
      return [result]
    },
    specInContainerQty() {
      return (row) => {
        return multiply(row.unitInContainerQty, row.specInUnitQty)
      }
    },
  },
  methods: {
    cellClassName() {
      return 'align-top'
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    .el-input-number {
      margin-top: 10px !important;
    }
  }
}
</style>
